/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrainingPlayerSettingsRequest
 */
export interface TrainingPlayerSettingsRequest {
    /**
     * 
     * @type {number}
     * @memberof TrainingPlayerSettingsRequest
     */
    baseFeeOverride?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingPlayerSettingsRequest
     */
    invitedEmail?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrainingPlayerSettingsRequest
     */
    sendInvitation?: boolean | null;
}

/**
 * Check if a given object implements the TrainingPlayerSettingsRequest interface.
 */
export function instanceOfTrainingPlayerSettingsRequest(value: object): value is TrainingPlayerSettingsRequest {
    return true;
}

export function TrainingPlayerSettingsRequestFromJSON(json: any): TrainingPlayerSettingsRequest {
    return TrainingPlayerSettingsRequestFromJSONTyped(json, false);
}

export function TrainingPlayerSettingsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingPlayerSettingsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'baseFeeOverride': json['baseFeeOverride'] == null ? undefined : json['baseFeeOverride'],
        'invitedEmail': json['invitedEmail'] == null ? undefined : json['invitedEmail'],
        'sendInvitation': json['sendInvitation'] == null ? undefined : json['sendInvitation'],
    };
}

export function TrainingPlayerSettingsRequestToJSON(json: any): TrainingPlayerSettingsRequest {
    return TrainingPlayerSettingsRequestToJSONTyped(json, false);
}

export function TrainingPlayerSettingsRequestToJSONTyped(value?: TrainingPlayerSettingsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'baseFeeOverride': value['baseFeeOverride'],
        'invitedEmail': value['invitedEmail'],
        'sendInvitation': value['sendInvitation'],
    };
}

